if ($('.js-promo').length === 0) {
	$('body').removeClass('has_banner_top');
}

$(document).on('click', '.js-promoClose', function() {
	$(this).parents('.js-promo').remove();

	$('body').removeClass('has_banner_top');
});